module.exports = __webpack_public_path__ + "static/media/battery-yellow.48a3984b.svg";